import EmployeeAddPage from './EmployeeAddPage';

export default EmployeeAddPage;
